import {
  deliveryEstimateSelectorSchema,
  SelectorType,
} from "@redotech/redo-model/conversion/storefront-delivery-estimate";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateStorefrontDeliveryEstimateSelector = {
  name: "updateStorefrontDeliveryEstimateSelector" as const,
  input: z.object({
    selector: deliveryEstimateSelectorSchema,
    selectorType: createEnum(SelectorType),
  }),
  output: z.null(),
};
